// src/services/register.ts
import { setSmartStorageItem } from "@/utils/smartStorage";
import axios from "axios";

export interface registerResponse {
    success: boolean;
    user?: {
        id: number;
        username: string;
        role: string;
    };
    token?: string;  // JWT token
    message?: string;
}

export const register = async (
    username: string,
    password: string
): Promise<registerResponse> => {
    try {
        const response = await axios.post(
            "https://portfoliom-backend.vercel.app/auth/register",
            { username, password }
        );

        if (response.data?.success) {
            const { user, token } = response.data;

            // Token ve role direkt burada kaydediliyor
            if (token) localStorage.setItem("token", token);
            if (user?.role) setSmartStorageItem("role", user.role, 3600);

            return { success: true, user, token };
        }

        return { success: false, message: response.data.message };
    } catch (err) {
        return { success: false, message: "Kayıt sırasında hata oluştu" };
    }
};